import { Profile } from "@/features/Profile/Profile";

const ProfileView = () => <Profile />;

export default ProfileView;
